export default () => import(/* webpackChunkName: "tinymce" */ './template.vue')
